import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import { kebabCaseToCamelCase } from '../../utils/vuex';
import debounce from 'lodash/debounce';
import { templateLocals } from '../../utils/emailTemplateVariables';
import ApiService from '../../services/apiService';
export default {
  name: 'SettingsEmailTemplate',
  props: {
    id: {
      type: String,
      default: '',
      required: true
    },
    title: {
      type: String,
      default: '',
      required: true
    },
    subject: {
      type: String,
      default: '',
      required: true
    },
    body: {
      type: String,
      default: '',
      required: true
    },
    varsSubject: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    varsBody: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      internalSubject: this.subject,
      internalBody: this.body,
      errorSubject: false,
      errorBody: false,
      isEmpty: false,
      showPreviewDialog: false,
      borderColor: this.color,
      previewSubject: '',
      previewBody: ''
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['image', 'color', 'inpOutlined', 'inpFilled', 'UiTheme'])), {}, {
    inputTemplateStyle: function inputTemplateStyle() {
      return ['font-family: monospace;', 'font-weight: 500;', 'font-size: 14px;', 'line-height: 1.5em;', 'white-space: pre-wrap;', 'tab-size: 2;', '-webkit-tab-size: 2;', '-moz-tab-size: 2;', '-o-tab-size: 2;;'].join(' ');
    },
    isMobile: function isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    }
  }),
  watch: {
    internalBody: debounce(function () {
      this.checkTemplateState();
      this.renderTemplate();
    }, 200),
    internalSubject: debounce(function () {
      this.checkTemplateState();
      this.renderTemplate();
    }, 200),
    subject: function subject() {
      this.internalSubject = this.subject;
    },
    body: function body() {
      this.internalBody = this.body;
    }
  },
  methods: {
    renderTemplate: function renderTemplate() {
      var _this = this;

      return ApiService.renderEmailTemplate(this.internalSubject, this.internalBody, templateLocals).then(function (data) {
        _this.errorSubject = data.errors.errorSubject ? data.errors.errorSubject : false;
        _this.errorBody = data.errors.errorBody ? data.errors.errorBody : false;
        return {
          subject: data.subject,
          body: data.body
        };
      });
    },
    handleShowSubjectError: function handleShowSubjectError() {
      this.previewSubject = this.$i18n_t('accMgmt.system.errorTemplateRender');
      this.previewBody = "<pre>".concat(this.errorSubject, "</pre>");
      this.showPreviewDialog = true;
    },
    handleShowBodyError: function handleShowBodyError() {
      this.previewSubject = this.$i18n_t('accMgmt.system.errorTemplateRender');
      this.previewBody = "<pre>".concat(this.errorBody, "</pre>");
      this.showPreviewDialog = true;
    },
    handlePreview: function handlePreview() {
      var _this2 = this;

      this.renderTemplate().then(function (result) {
        var subject = result.subject,
            body = result.body;
        var error = _this2.errorSubject || _this2.errorBody;

        if (error) {
          _this2.previewSubject = _this2.$i18n_t('accMgmt.system.errorTemplateRender');
          _this2.previewBody = "<pre>".concat(error, "</pre>");
        } else {
          _this2.previewSubject = subject;
          _this2.previewBody = body;
        }

        _this2.showPreviewDialog = true;
      }).catch(function (error) {
        console.error(error);
      });
    },
    checkTemplateState: function checkTemplateState() {
      this.isEmpty = !this.internalBody || !this.internalSubject;
    },
    getTemplateTitle: function getTemplateTitle(key) {
      return this.$i18n_t("accMgmt.system.email.templateNames.".concat(kebabCaseToCamelCase(key)));
    },
    getVariableName: function getVariableName(key) {
      return this.$i18n_t("accMgmt.system.email.templateVariables.".concat(key));
    },
    updateSubject: function updateSubject(content) {
      this.$emit('update', this.id, 'subject', content);
    },
    updateBody: function updateBody(content) {
      this.$emit('update', this.id, 'body', content);
    },
    handleTemplateKeydown: function handleTemplateKeydown(e) {
      if (e.key === 'Tab' || e.keyCode === 9) {
        e.preventDefault();
        var el = e.target;
        var selectionStart = el.selectionStart;
        var selectionEnd = el.selectionEnd;
        var indentation = '\t';
        this.internalBody = "".concat(el.value.slice(0, selectionStart)).concat(indentation).concat(el.value.slice(selectionEnd));
        this.$nextTick(function () {
          el.setSelectionRange(selectionStart + indentation.length, selectionStart + indentation.length);
        });
      }
    }
  }
};